import React from "react";
import PropTypes from "prop-types";
import { getStoryHeadline, getStoryLabel } from "../../../utils/story";
import { Label } from "../../../atoms/Label";
import Headline from "../../../atoms/Headline";

import "../three-col-six-stories.m.css";

const CardInfo = ({ story, sectionSlug }) => {
  const headline = getStoryHeadline(story);
  const label = getStoryLabel(story);
  return (
    <div styleName="headline-container">
      {label && <Label story={story} />}

      {headline && <Headline styleName="headline" headline={headline} sectionSlug={sectionSlug} />}
    </div>
  );
};

CardInfo.propTypes = {
  story: PropTypes.shape({}),
  isHeroStory: PropTypes.bool,
  sectionSlug: PropTypes.string,
};

export default CardInfo;
